// extracted by mini-css-extract-plugin
export default {"fwrkLogin":"NewLogin_fwrkLogin__FP0Me"};